<template>
  <div class="app-container">
    <list ref="list" @type-change="typeChange" @change="onChange" @reload="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
    </list>
    <template v-if="type!=2&&type!=3">
      <div class="list-head" style="margin-top: 10px;">{{Tb1Label}}</div>
      <el-table class="tb-c-head" border :data="Details1" v-loading="loading1" show-summary>
        <el-table-column label="单据类型" min-width="80"  align="center" >
          <template slot-scope="{row}">{{row.SourceTypeName}}</template>
        </el-table-column>
        <el-table-column label="单据日期" min-width="100"  align="center" >
          <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
        </el-table-column>
        <el-table-column label="单据编号" min-width="150"  align="center" show-overflow-tooltip>
          <template slot-scope="{row}">{{row.DocNo}}</template>
        </el-table-column>
        <el-table-column label="往来单位" min-width="150"  align="center" >
          <template slot-scope="{row}">{{row.TradeUnitName}}</template>
        </el-table-column>
        <el-table-column prop="DpName" label="部门"  align="center" />
        <el-table-column label="经办人" min-width="90"  align="center" >
          <template slot-scope="{row}">{{row.ClerkName}}</template>
        </el-table-column>
        <el-table-column prop="Amount" label="金额" width="120"  align="center" v-if="canPrice">
          <template slot-scope="{row}">{{row.Amount.toLocaleString()}}</template>
        </el-table-column>
        <el-table-column prop="NoSettleAmount" label="应核销金额" width="120"  align="center" v-if="canPrice" />
        <el-table-column prop="WriteoffAmount" label="本次销金额" width="120"  align="center" v-if="canPrice" />
      </el-table>
    </template>
    <div class="list-head" style="margin-top: 10px;">{{Tb2Label}}</div>
    <el-table class="tb-c-head" border :data="Details2" v-loading="loading2" show-summary>
      <el-table-column label="单据类型" min-width="80"  align="center" >
        <template slot-scope="{row}">{{row.SourceTypeName}}</template>
      </el-table-column>
      <el-table-column label="单据日期" min-width="100"  align="center"   >
        <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
      </el-table-column>
      <el-table-column label="单据编号" min-width="150"  align="center" show-overflow-tooltip>
        <template slot-scope="{row}">{{row.DocNo}}</template>
      </el-table-column>
      <el-table-column label="往来单位" min-width="150"  align="center" >
        <template slot-scope="{row}">{{row.TradeUnitName}}</template>
      </el-table-column>
      <el-table-column prop="DpName" label="部门"  align="center" />
      <el-table-column label="经办人" min-width="90"  align="center" >
        <template slot-scope="{row}">{{row.ClerkName}}</template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额" width="120"  align="center" v-if="canPrice">
        <template slot-scope="{row}">{{row.Amount.toLocaleString()}}</template>
      </el-table-column>
      <el-table-column prop="NoSettleAmount" label="应核销金额" width="120"  align="center" v-if="canPrice" >
        <template slot-scope="{row}">{{Number(row.NoSettleAmount.toFixed(2))}}</template>
      </el-table-column>
      <el-table-column prop="WriteoffAmount" label="本次销金额" width="120"  align="center" v-if="canPrice">
        <template slot-scope="{row}">{{Number(row.WriteoffAmount.toFixed(2))}}</template></el-table-column>
    </el-table>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <check-dialog ref="checkDialog" @confirm="confirm" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/finance/dealings/chargeoff/list";
import editDialog from "@/components/finance/dealings/chargeoff/editDialog";
import checkDialog from "@/components/finance/dealings/chargeoff/checkDialog";

export default {
  name: "chargeoff",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    checkDialog,
  },
  data() {
    return {
      rp_api: require("@/api/rp/settleDocRp").default,
      wo_api: require("@/api/rp/settleDocWo").default,
      Details1: [], //预收/付明细
      Details2: [], //核销明细
      loading1: false,
      loading2: false,
      type: 0,
      isMB: this.$store.state.isMB,
    };
  },
  computed: {
    Tb1Label() {
      if (this.type == 0) return "预收明细";
      else if (this.type == 1) return "预付明细";
      else if (this.type == 4) return "应收明细";
      else return "单据明细";
    },
    Tb2Label() {
      if (this.type == 0) return "应收明细";
      else if (this.type == 1) return "应付明细";
      else if (this.type == 4) return "应付明细";
      else return "单据明细";
    },
    canPrice() {
      return this.$permission.canPrice("/finance/dealings/chargeoff");
    },
  },
  methods: {
    
    reload() {
      this.$refs.list.reload();
      this.Details1 = [];
      this.Details2 = [];
    },
    onChange(row) {
      console.log("选中行", JSON.parse(JSON.stringify(row)));
      this.Details1 = [];
      this.Details2 = [];
      this.loading1 = true;
      this.rp_api.list({ SettleDocId: row.SettleDocId }).then((res) => {
        this.loading1 = false;
        if (res.Code == 0) this.Details1 = res.Data;
      });
      this.loading2 = true;
      this.wo_api.list({ SettleDocId: row.SettleDocId }).then((res) => {
        this.loading2 = false;
        if (res.Code == 0) this.Details2 = res.Data;
      });
    },
    typeChange(type) {
      this.type = type; //预收冲应收、预付冲应付、应收冲应收、应付冲应付、应收冲应付
      this.Details1 = [];
      this.Details2 = [];
    },
    create() {
      this.$refs.checkDialog.open();
    },
    confirm(data) {
      this.$refs.editDialog.openCreate(data);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.SettleDocId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>